const initialState = { 
  loading: false,
  success: null,
  error: null
}

function deleteAgentReducer(state = initialState, action) {
  switch (action.type) {
    case 'DELETE_AGENT_BEGIN':
      return {
        ...state,
        loading: true,
        success: null,
        error: null
      }

    case 'DELETE_AGENT_SUCCESS':
      return {
        ...state,
        loading: false,
        success: action.success
      }

    case 'DELETE_AGENT_FAILURE':
      return {
        ...state,
        loading: false,
        error: action.error
      }

    default: return state
  }
}

export default deleteAgentReducer